"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ABM", {
  enumerable: true,
  get: function get() {
    return _Category.ABM;
  }
});
Object.defineProperty(exports, "ANALYTICS", {
  enumerable: true,
  get: function get() {
    return _Category.ANALYTICS;
  }
});
Object.defineProperty(exports, "AUTOMATION", {
  enumerable: true,
  get: function get() {
    return _Category.AUTOMATION;
  }
});
Object.defineProperty(exports, "CMS", {
  enumerable: true,
  get: function get() {
    return _Category.CMS;
  }
});
Object.defineProperty(exports, "DATA_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _Category.DATA_MANAGEMENT;
  }
});
Object.defineProperty(exports, "ECOMMERCE", {
  enumerable: true,
  get: function get() {
    return _Category.ECOMMERCE;
  }
});
Object.defineProperty(exports, "EMAIL", {
  enumerable: true,
  get: function get() {
    return _Category.EMAIL;
  }
});
Object.defineProperty(exports, "EVENT", {
  enumerable: true,
  get: function get() {
    return _Category.EVENT;
  }
});
Object.defineProperty(exports, "LEAD_GEN", {
  enumerable: true,
  get: function get() {
    return _Category.LEAD_GEN;
  }
});
Object.defineProperty(exports, "LIVE_CHAT", {
  enumerable: true,
  get: function get() {
    return _Category.LIVE_CHAT;
  }
});
Object.defineProperty(exports, "PPC", {
  enumerable: true,
  get: function get() {
    return _Category.PPC;
  }
});
Object.defineProperty(exports, "SEO", {
  enumerable: true,
  get: function get() {
    return _Category.SEO;
  }
});
Object.defineProperty(exports, "SOCIAL", {
  enumerable: true,
  get: function get() {
    return _Category.SOCIAL;
  }
});
Object.defineProperty(exports, "VIDEO", {
  enumerable: true,
  get: function get() {
    return _Category.VIDEO;
  }
});
Object.defineProperty(exports, "WEBINAR", {
  enumerable: true,
  get: function get() {
    return _Category.WEBINAR;
  }
});
Object.defineProperty(exports, "WEBSITE", {
  enumerable: true,
  get: function get() {
    return _Category.WEBSITE;
  }
});
Object.defineProperty(exports, "WORDPRESS", {
  enumerable: true,
  get: function get() {
    return _Category.WORDPRESS;
  }
});

var _Category = require("../Category");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/superCategoryGroups/Marketing.js
// module id = 593
// module chunks = 209 210 211 212 213